//
//
//
//
//
//

export default {
  name: 'Shipping',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      imageUrl: '',
      menuTitle: '',
      menuItems: [],
    }
  },
}
